import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import SpeedTestAndDisconnectionsWizardBlockData from '../../../Models/Content/SpeedTestAndDisconnectionsWizardBlockData';
import SpeedTestAndDisconnectionsWizard from './SpeedTestAndDisconnectionsWizardBlock';

export default class SpeedTestAndDisconnectionsWizardBlock extends EpiComponent<SpeedTestAndDisconnectionsWizardBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <SpeedTestAndDisconnectionsWizard context={this.getContext()} iContent={this.props.data}/>;
  }
}
